import React, { useState, useEffect } from "react";
import chek from "../../images/check.svg";
import pen from "../../images/pen.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LandingPage from "../LandingPage";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";
export default function Prricing() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const Product = () => {
    const reqBody = {
      add_quantity: 1,
    };
    axiosInstance.post(API_URLS.productList, reqBody).then((response) => {
      setData(response.data.data.product_list);
    });
  };

  useEffect(() => {
    Product();
  }, []);

  return (
    <div>
      <div className="lazyload-wrapper">
        <div className=" pr">
          <div className="pr1">
            <div className="pr2">
              <h2 className=" pr3">Ready to start</h2>
              <p className="pr4">Get access to all our premium plan</p>
            </div>
            <div className="pr5">
              <div className="pr11">
                {data?.slice(0, 1).map((product) => {
                  return (
                    <>
                      <div className=" pr12 lg:grid grid-cols-3 ">
                        <div className="pr13  background background1"></div>
                        <div className=" pr14 card">
                          <div className="pr15">
                            <p className="pr16">{product.title}</p>
                            <h1 className="pr17">₹ {product.actual_price}</h1>
                            <p className="font-bold">{product.variant_name}</p>
                            <div className="pr19">
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">{product.slug}</p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">
                                  Status :<span> {product.stock_sataus}</span>
                                </p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">{product.variant_name}</p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                              </div>
                            </div>
                          </div>
                          <button className="pr23">
                            <div className="pr24 ">
                              <div className="pr25">
                                <img alt="" src={pen} className="pt-5" />
                              </div>
                            </div>
                            <div className="pr27">
                              <p
                                className="pr28"
                                onClick={() =>
                                  navigate(`/product/${product?.id}`)
                                }
                              >
                                More Plan
                              </p>
                              <p className="pr29"></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  );
                })}
                {data?.slice(1, 2).map((product) => {
                  return (
                    <>
                      <div className=" pr12">
                        <div className="pr30  "></div>
                        <div className="pr31 card">
                          <div className="pr15">
                            <p className="pr16">{product.main_category}</p>
                            <h1 className="pr17">₹ {product.price}</h1>
                            <p className="pr32">{product.title}</p>
                            <div className="pr19">
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">{product.slug}</p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">
                                  Status :<span> {product.stock_sataus}</span>
                                </p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">{product.variant_name}</p>
                              </div>

                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">10 database</p>
                              </div>
                            </div>
                          </div>
                          <button className="pr23">
                            <div className="pr24 ">
                              <div className="pr25">
                                <img alt="" src={pen} className="pt-5" />
                              </div>
                            </div>
                            <div className="pr27">
                              <p
                                className="pr28"
                                onClick={() =>
                                  navigate(`/product/${product?.id}`)
                                }
                              >
                                More Plan
                              </p>
                              <p className="pr29"></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  );
                })}

                {data?.slice(2, 3).map((product) => {
                  return (
                    <>
                      <div className=" pr12">
                        <div className="pr33  "></div>
                        <div className="pr34 card">
                          <div className="pr15">
                            <p className="pr16">{product.main_category}</p>
                            <h1 className="pr17">₹ {product.price}</h1>
                            <p className="bA-DAlP">{product.title}</p>
                            <div className="pr19">
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">{product.slug}</p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">
                                  Status :<span> {product.stock_sataus}</span>
                                </p>
                              </div>
                              <div className="pr20">
                                <img alt="" src={chek} className="pr22" />
                                <p className="pr21">
                                  <p className="pr21">{product.variant_name}</p>
                                </p>
                              </div>
                            </div>
                          </div>
                          <button className="pr23">
                            <div className="pr24 ">
                              <div className="pr25">
                                <img alt="" src={pen} className="pt-5" />
                              </div>
                            </div>
                            <div className="pr27">
                              <p
                                className="pr28"
                                onClick={() =>
                                  navigate(`/product/${product?.id}`)
                                }
                              >
                                More Plan
                              </p>
                              <p className="pr29"></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingPage />
    </div>
  );
}
